export const MapRoutesToFlyMenu = (routes) =>
    routes?.map(route => ({
        menu_details: {
            title: route.name,
            icon: route.icon
        },
        submenus: {
            allmenu: route.subRoutes
                .filter(r => r.path)
                .map(r => ({
                    DiplayName: r.name,
                    Icon: r.icon,
                    path: r.path
                })),
            ...route.subRoutes
                .filter(r => r.subRoutes)
                .reduce((acc, r) => {
                    acc[r.name] = r.subRoutes.map(sr => ({
                        DiplayName: sr.name,
                        Icon: sr.icon,
                        path: sr.path
                    }));
                    return acc;
                }, {})
        }
    }));
